export default __webpack_public_path__ + "static/media/99.3a3f69b7.jpg";